<template>
  <div :class="`card-info ${isFull === true ? 'full' : ''}`">
    <div class="content">
      <card>
        <header-item :card="card" />
        <tabs v-show="tabs.length > 1" :tabs="tabs" v-model="current" />
        <div> <h2 v-if="!disableId" class="text-info"># {{ id }}</h2></div>
        <template v-for="(tab, key) in tabs">
          <component
            v-if="current === key"
            :is="tab.component"
            :id="id"
            :key="key"
            :model="tab['model']"
          />
        </template>
        <slot></slot>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  props: ["card", "value", "tabs", "id", "isFull", "disableId"],
  components: {
    HeaderItem: () => import("./HeaderItem"),
  },
  computed: {
    current: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>